export const circularsData=[
    {
      "id": 1,
      "heading": "RUHS Affilication Letter",
      "description": "Affiliation letter for D.Pharm course",
      "link": "https://drive.google.com/file/d/157lnKZEMybv_oHqrdUw3tPbUcjTXBARx/view?usp=sharing"
    },
    {
      "id": 2,
      "heading": "PCI Decision Letter",
      "description": "D.Pharm Grant last approval letter",
      "link": "https://drive.google.com/file/d/1qnVebqY5c6RRN_a1md9eLNLiIQpQphjw/view?usp=sharing"
    },
    // Add more circulars as needed
  ];